module.exports = __webpack_public_path__ + "img/text03.2efecec0.png";